import React, { useState, useEffect, useCallback } from 'react'
import { Button } from 'react-bootstrap'
import { ButtonWithLoadingState } from '../../Buttons'
import { Alert } from 'react-bootstrap'
import { getErrorMessageFromApiResponse } from '../../../utils/api/apiUtils'
import instMgmtApi from '../../../utils/api/instanceMgmt/instMgmtApi'
import ScanCodeData from '../ScanCodeData'
import DisposalModal from '../DisposalModal'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'

const StyledButtonsWrapper = styled.div`
    .btn {
        margin: 4px;
    }
    display: flex;
    width: 100%;
    justify-content: space-between;
    
    @media screen and (max-width: 767px) {
        flex-direction: column;
        width: 100%;
    }
`
const CloseControlJob = (props) => {
    const { t, washStore, scanCodeObj, disabledDisposal, handleClose, setScanCodeObj } = props
    const [openDisposalModal, setOpenDisposalModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [currentJob, setCurrentJob] = useState(null)

    const loadCurrentJob = useCallback(async () => {
        try {
            setLoading(true)
            let jobs = await instMgmtApi.getWashOpenJobsForScanCode(scanCodeObj.rfid, washStore.selectedWashStationId)
            let job = jobs.find(obj => obj.type === "isControlJob")
            if(!!job)
            {
                setCurrentJob(job)
            }
        }
        catch (e) {
            setError(getErrorMessageFromApiResponse(e))
        }
        finally {
            setLoading(false)
        }
    }, [scanCodeObj.rfid, washStore.selectedWashStationId])

    const disposeRFID = async () => {
        setOpenDisposalModal(true)
    }
    const handleCloseDisposalModal = async (disposed) => {
        setOpenDisposalModal(false)
        if (disposed) {
            handleClose(false)
        }
    }
    const completeJob = async () => {
        try {
            setLoading(true)
            let params = {
                action: 'closeControlJob',
                additionalWashCycles: scanCodeObj?.additionalWashCycles ?? 0,
                comment: scanCodeObj?.comment ?? '',
                stationId: washStore.selectedWashStationId
            }
            await instMgmtApi.postScanCodeAction(scanCodeObj.rfid, params)

            handleClose(true)
        }
        catch (e) {
            setError(getErrorMessageFromApiResponse(e))
        }
        finally {
            setLoading(false)
        }
    }
    const createJob = async (action) => {
        try {
            setLoading(true)
            let params = {
                action: action,
                stationId: washStore.selectedWashStationId
            }
            await instMgmtApi.postScanCodeAction(scanCodeObj.rfid, params)
            let result = await instMgmtApi.getScanCodeInfo(scanCodeObj.rfid)
            setScanCodeObj(result);
            //handleClose(true)
        }
        catch (e) {
            setError(getErrorMessageFromApiResponse(e))
        }
        finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        loadCurrentJob()
    }, [loadCurrentJob])

    return (
        <div className='mb-3'>
            <h2>{t('washPage:controlJob')}</h2>
            <ScanCodeData scanCodeObj={scanCodeObj} setScanCodeObj={setScanCodeObj} editable={scanCodeObj?.hasControlJob} currentJobObj={currentJob} disableComment={false}/>
            {error ? <Alert variant="danger">{error}</Alert> : null}
            <StyledButtonsWrapper>
                {washStore.checkWashActionIsAllowed('closeControlJob') && scanCodeObj?.hasControlJob &&
                    <ButtonWithLoadingState
                        className='mb-2'
                        buttonText={t('washPage:closeJob')}
                        onClick={completeJob}
                        loading={loading}
                        disabled={loading || !scanCodeObj?.hasControlJob}
                    />}
                {washStore.checkWashActionIsAllowed('createRepairJob') && <ButtonWithLoadingState
                    className='mb-2'
                    buttonText={t('washPage:repairJob')}
                    onClick={(e) => createJob('createRepairJob')}
                    loading={loading}
                    disabled={loading || !!scanCodeObj?.hasRepairJob}
                />}
                {(!disabledDisposal && washStore.checkWashActionIsAllowed('disposed')) && <ButtonWithLoadingState
                    className='mb-2'
                    buttonText={t('washPage:discardArticle')}
                    onClick={disposeRFID}
                />}
                <Button className='mb-2' variant="secondary" onClick={(e) => handleClose(false)}>{t('cancelButton')}</Button>
            </StyledButtonsWrapper>
            {washStore.createErrorCode(scanCodeObj) ? <Alert variant="danger">{washStore.createErrorCode(scanCodeObj)}</Alert> : null}
            {washStore.createInfoCode(scanCodeObj) ? <Alert variant="info">{washStore.createInfoCode(scanCodeObj)}</Alert> : null}
            {openDisposalModal ? (
                <DisposalModal
                    scanCodeObj={scanCodeObj}
                    handleClose={handleCloseDisposalModal}
                />
            ) : null}
        </div>
    )
}

export default withTranslation()(
    inject(
        'washStore',
    )(observer(CloseControlJob))
)
